import { AxiosInstance } from 'axios';
import createTimetablesWebApiHttpClient from './createTimetablesWebApiHttpClient';

class RoomApi {
    httpClient: AxiosInstance;

    constructor() {
        this.httpClient = createTimetablesWebApiHttpClient();
    }

    async GetRoomTypes() {
        const { data } = await this.httpClient.get('/rooms/room-types');
        return data;
    }

    async GetRooms(buildingId?: number) {
        let url = `/rooms`;

        if (buildingId) {
            url += `?buildingId=${buildingId}`;
        }

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async UpdateRoom(room: any) {
        const payload = {
            id: room.id,
            number: room.number,
            capacity: parseInt(room.capacity),
            typeId: room.roomType?.id,
            description: room.description,
            configuration: room.configuration,
            schoolId: room.schoolId,
            isActive: room.isActive,
        };

        const { data } = await this.httpClient.put(`/rooms/${room.id}`, payload);
        return data;
    }

    async RoomSearch(buildingId: number, days: Array<number>, startDate: string, endDate: string, timeIn: string, timeOut: string, maxSlotsOccupied: number) {
        const daysParameter = days.reduce((previousValue, currentValue) => {
            return previousValue + '&dayIds=' + currentValue;
        }, '');

        let endpoint = `/rooms/search?buildingId=${buildingId}${daysParameter}&timeIn=${timeIn}&timeOut=${timeOut}&startDate=${startDate}&endDate=${endDate}&maxSlotsOccupied=${maxSlotsOccupied}`;

        const { data } = await this.httpClient.get(endpoint);

        return data;
    }

    async ExportRoomBookingReport(rooms: Array<number>, startDate: string, endDate: string) {
        const roomIdParameter = rooms.reduce((previousValue, currentValue) => {
            return previousValue + '&roomId=' + currentValue;
        }, '');

        const { data } = await this.httpClient.get(`/rooms/export?${roomIdParameter}&startDate=${startDate}&endDate=${endDate}`, { responseType: 'arraybuffer' });
        
        return data;
    }
}

export default RoomApi;
